import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const ToggleSwitch = Styled(
  createSvgIcon(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 64 64"
      xmlSpace="preserve"
    >
      <path
        d="M24.5 17C16.492 17 10 23.492 10 31.5S16.492 46 24.5 46 39 39.508 39 31.5 32.508 17 24.5 17zM14 31.5C14 25.701 18.701 21 24.5 21S35 25.701 35 31.5 30.299 42 24.5 42 14 37.299 14 31.5z"
        fill="currentColor"
        opacity="1"
      ></path>
      <path
        d="M25 9C12.297 9 2 19.297 2 32s10.297 23 23 23h14c12.703 0 23-10.297 23-23S51.703 9 39 9zM6 32c0-10.493 8.507-19 19-19h14c10.493 0 19 8.507 19 19s-8.507 19-19 19H25C14.507 51 6 42.493 6 32z"
        fill="currentColor"
        opacity="1"
      ></path>
    </svg>,
    "ToggleSwitch",
  ),
);

export default ToggleSwitch;
